import React from 'react';

import { flagStyles } from '../settings';

const SvgTG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5136px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTG;
